export enum RationaleConfigValues {
  DISABLED_FOR_TENANT = 'Disabled for tenant',
  ENABLED_FOR_TENANT = 'Enabled for tenant',
  ENABLED_FOR_SPECIFIC_PROJECTS = 'Enabled for specific projects',
}

export enum ConfigNames {
  AUDITING_DATA_MODIFICATIONS_SETTING = 'AUDITING_DATA_MODIFICATIONS_SETTING',
  AUDITING_ALLOW_MOVE_FROM_DATA_MODIFICATIONS_ENABLED_PROJECT = 'AUDITING_ALLOW_MOVE_FROM_DATA_MODIFICATIONS_ENABLED_PROJECT',
  AUDITING_ALLOW_MOVE_TO_DATA_MODIFICATIONS_ENABLED_PROJECT = 'AUDITING_ALLOW_MOVE_TO_DATA_MODIFICATIONS_ENABLED_PROJECT',
  AUDITING_DATA_MODIFICATIONS_REASONS_FOR_CHANGE = 'AUDITING_DATA_MODIFICATIONS_REASONS_FOR_CHANGE',
  AUDITING_DATA_MODIFICATIONS_COMMENT_OPTIONAL = 'AUDITING_DATA_MODIFICATIONS_COMMENT_OPTIONAL',
}
